<template>
  <div class="page-wrapper">
    <b-button-group
      class="
        px-3
        w-100
        submit-form-btn
        btn-group
        d-inline-block
        text-center
        mt-4
        mb-3
      "
    >
      <b-button class="max-w-auto" variant="outline-primary" @click="navigateToProfile"
        >Your CCI Landing Page</b-button
      >
    </b-button-group>

    <div class="w-80 mx-auto mt-3 mb-4">
      <h4 class="form-title">Core Capacities Index Assessment</h4>
      <p class="mt-3 text-center">
        The Core Capacities Index (CCI) assessment is a recruiting evaluation
        based on a validated and proprietary assessment protocol that paints an
        accurate picture of a person’s Core Capacities. Core Capacities are the
        unique 'recipe' of organic talents that make up each of us. To learn
        more about the CCI assessment, message your account representative
        through the support button.
      </p>
    </div>
    <b-table
      :items="getUserCCIProfileList"
      :fields="fields"
      striped
      responsive="sm"
      class="core-capacity-table"
    >
      <template #cell(Emails)="data">
        {{ data.item.Emails ? data.item.Emails.join(", "): '' }}
        <span @click="editAssEmail(data)"><v-icon class="editAssEmail text-blue" name="edit"></v-icon></span>
      </template>
      <template #cell(Default)="data">
        {{ data.item.Default == true ? "Yes" : "No" }}
      </template>
      <template #cell(Profile)="row">
        <b-button size="sm" @click="row.toggleDetails" class="mr-2">
          Show Profile
        </b-button>
      </template>
      <template #cell(Delete)="row">
        <b-button
          style="width: 50%; float: left"
          variant="outline"
          @click="removeProfile(row.item)"
        >
          <v-icon class="text-blue" name="times" />
        </b-button>
      </template>
      <template #row-details="row">
        <div class="assessmentRangeTable RangeTableContent">
          <table>
              <thead>
                  <tr>
                      <th scope="col">CAPACITIES</th>
                      <th scope="col" colspan="2">
                          <u>Desired Range</u>
                          <br>Low
                      </th>
                      <th scope="col" colspan="2">
                          <u>Desired Range</u>
                          <br>High
                      </th>
                  </tr>
              </thead>
              <tbody>
                  <tr>
                      <td>Builder</td>
                      <td scope="row" colspan="2">{{ row.item.BuilderLower ? row.item.BuilderLower : 0 }}</td>
                      <td scope="row" colspan="2">{{ row.item.BuilderUpper ? row.item.BuilderUpper : 36 }}</td>
                  </tr>
                  <tr>
                      <td>Merchant</td>
                      <td scope="row" colspan="2">{{ row.item.MerchantLower ? row.item.MerchantLower : 0 }}</td>
                      <td scope="row" colspan="2">{{ row.item.MerchantUpper ? row.item.MerchantUpper : 36 }}</td>
                  </tr>
                  <tr>
                      <td>Innovator</td>
                      <td scope="row" colspan="2">{{ row.item.InnovatorLower ? row.item.InnovatorLower : 0 }}</td>
                      <td scope="row" colspan="2">{{ row.item.InnovatorUpper ? row.item.InnovatorUpper : 36 }}</td>
                  </tr>
                  <tr>
                      <td>Banker</td>
                      <td scope="row" colspan="2">{{ row.item.BankerLower ? row.item.BankerLower : 0 }}</td>
                      <td scope="row" colspan="2">{{ row.item.BankerUpper ? row.item.BankerUpper : 36 }}</td>
                  </tr>
              </tbody>
              <div class="typesTitle">TYPES</div>
              <tbody>
                  <tr>
                      <td>Community</td>
                      <td colspan="2">{{ row.item.CommunityLower ? row.item.CommunityLower : 0 }}</td>
                      <td colspan="2">{{ row.item.CommunityUpper ? row.item.CommunityUpper : 72 }}</td>
                  </tr>
                  <tr class="border-class">
                      <td>Independent</td>
                      <td colspan="2">{{ row.item.IndependentLower ? row.item.IndependentLower : 0 }}</td>
                      <td colspan="2">{{ row.item.IndependentUpper ? row.item.IndependentUpper : 72 }}</td>
                  </tr>
                  <tr>
                      <td>Intuitive</td>
                      <td colspan="2">{{ row.item.IntuitiveLower ? row.item.IntuitiveLower : 0 }}</td>
                      <td colspan="2">{{ row.item.IntuitiveUpper ? row.item.IntuitiveUpper : 72 }}</td>
                  </tr>
                  <tr class="border-class">
                      <td>Cognitive</td>
                      <td colspan="2">{{ row.item.CognitiveLower ? row.item.CognitiveLower : 0 }}</td>
                      <td colspan="2">{{ row.item.CognitiveUpper ? row.item.CognitiveUpper : 72 }}</td>
                  </tr>
                  <tr>
                      <td>Practical</td>
                      <td colspan="2">{{ row.item.PracticalLower ? row.item.PracticalLower : 0 }}</td>
                      <td colspan="2">{{ row.item.PracticalUpper ? row.item.PracticalUpper : 72 }}</td>
                  </tr>
                  <tr>
                      <td>Creative</td>
                      <td colspan="2">{{ row.item.CreativeLower ? row.item.CreativeLower : 0 }}</td>
                      <td colspan="2">{{ row.item.CreativeUpper ? row.item.CreativeUpper : 72 }}</td>
                  </tr>
              </tbody> 
          </table>
        </div>
        <!--
        <b-card>
          <div class="range-slider-wrapper d-flex align-items-center greysection">
            <span class="mr-3 range-slider-label">Builder</span>
            <MultiRangeSlider
              :min="0"
              :max="36"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="row.item.BuilderLower"
              :maxValue="row.item.BuilderUpper"
              @input="UpdateBuilderValues"
            />
          </div>

          <div class="range-slider-wrapper d-flex align-items-center whitesection">
            <span class="mr-3 range-slider-label">Merchant</span>
            <MultiRangeSlider
              :min="0"
              :max="36"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="row.item.MerchantLower"
              :maxValue="row.item.MerchantUpper"
              @input="UpdateMerchantValues"
            />
          </div>

          <div class="range-slider-wrapper d-flex align-items-center greysection">
            <span class="mr-3 range-slider-label">Innovator</span>
            <MultiRangeSlider
              :min="0"
              :max="36"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="row.item.InnovatorLower"
              :maxValue="row.item.InnovatorUpper"
              @input="UpdateInnovatorValues"
            />
          </div>

          <div class="range-slider-wrapper d-flex align-items-center whitesection">
            <span class="mr-3 range-slider-label">Banker</span>
            <MultiRangeSlider
              :min="0"
              :max="36"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="row.item.BankerLower"
              :maxValue="row.item.BankerUpper"
              @input="UpdateBankerValues"
            />
          </div>

          <div class="range-slider-wrapper d-flex align-items-center greysection">
            <span class="mr-3 range-slider-label">Intuitive</span>
            <MultiRangeSlider
              :min="0"
              :max="72"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="row.item.IntuitiveLower"
              :maxValue="row.item.IntuitiveUpper"
              @input="UpdateIntuitiveValues"
            />
          </div>

          <div class="range-slider-wrapper d-flex align-items-center whitesection">
            <span class="mr-3 range-slider-label">Cognitive</span>
            <MultiRangeSlider
              :min="0"
              :max="72"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="row.item.CognitiveLower"
              :maxValue="row.item.CognitiveUpper"
              @input="UpdateCognitiveValues"
            />
          </div>

          <div class="range-slider-wrapper d-flex align-items-center greysection">
            <span class="mr-3 range-slider-label">Practical</span>
            <MultiRangeSlider
              :min="0"
              :max="72"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="row.item.PracticalLower"
              :maxValue="row.item.PracticalUpper"
              @input="UpdatePracticalValues"
            />
          </div>

          <div class="range-slider-wrapper d-flex align-items-center whitesection">
            <span class="mr-3 range-slider-label">Creative</span>
            <MultiRangeSlider
              :min="0"
              :max="72"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="row.item.CreativeLower"
              :maxValue="row.item.CreativeUpper"
              @input="UpdateCreativeValues"
            />
          </div>

          <div class="range-slider-wrapper d-flex align-items-center greysection">
            <span class="mr-3 range-slider-label">Independent</span>
            <MultiRangeSlider
              :min="0"
              :max="72"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="row.item.IndependentLower"
              :maxValue="row.item.IndependentUpper"
              @input="UpdateIndependentValues"
            />
          </div>

          <div class="range-slider-wrapper d-flex align-items-center whitesection">
            <span class="mr-3 range-slider-label">Community</span>
            <MultiRangeSlider
              :min="0"
              :max="72"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="row.item.CommunityLower"
              :maxValue="row.item.CommunityUpper"
              @input="UpdateCommunityValues"
            />
          </div>
        </b-card>
        -->
      </template>
    </b-table>

    <div v-if="isShow" class="w-100 mx-auto custom-form">
      <h5 class="form-title mt-4 mb-4">Create an Assessment Profile</h5>
      <b-form class="row manager-form">
        <b-form-group class="my-1 col-10 m-auto">
          <b-form-input
            class="slider-input mb-4 m-auto"
            type="text"
            placeholder="Profile Name"
            v-model="Name"
            required
          />
          <b-form-group class="mulEmail slider-input mb-4 m-auto">
              <multiselect v-model="selectedEmails" tag-placeholder="Enter email" placeholder="Add a email" :options=[] :multiple="true" :taggable="true" @tag="addAssessmentEmail" :hideSelected="true" :showLabels='false'>
              </multiselect>
          </b-form-group>
          <div class="assessmentRangeTable RangeTableContent">
            <table>
                <thead>
                    <tr>
                        <th scope="col">CAPACITIES</th>
                        <th scope="col" colspan="2">
                            <u>Desired Range</u>
                            <br>Low
                        </th>
                        <th scope="col" colspan="2">
                            <u>Desired Range</u>
                            <br>High
                        </th>
                    </tr>
                </thead>
                <tbody>
                  <tr>
                      <td>Builder</td>
                      <td colspan="2"><input v-model="BuilderLower" @input="handleRangeValue('BuilderLower',$event.target.value,36)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                      <td colspan="2"><input v-model="BuilderUpper" @input="handleRangeValue('BuilderUpper',$event.target.value,36)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                  </tr>
                  <tr>
                      <td>Merchant</td>
                      <td colspan="2"><input v-model="MerchantLower" @input="handleRangeValue('MerchantLower',$event.target.value,36)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                      <td colspan="2"><input v-model="MerchantUpper" @input="handleRangeValue('MerchantUpper',$event.target.value,36)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                  </tr>
                  <tr>
                      <td>Innovator</td>
                      <td colspan="2"><input v-model="InnovatorLower" @input="handleRangeValue('InnovatorLower',$event.target.value,36)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                      <td colspan="2"><input v-model="InnovatorUpper" @input="handleRangeValue('InnovatorUpper',$event.target.value,36)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                  </tr>
                  <tr>
                      <td>Banker</td>
                      <td colspan="2"><input v-model="BankerLower" @input="handleRangeValue('BankerLower',$event.target.value,36)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                      <td colspan="2"><input v-model="BankerUpper" @input="handleRangeValue('BankerUpper',$event.target.value,36)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                  </tr>
                </tbody>
                <div class="typesTitle">TYPES</div>
                <tbody>
                  <tr>
                      <td>Community</td>
                      <td colspan="2"><input v-model="CommunityLower" @input="handleRangeValue('CommunityLower',$event.target.value,72)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                      <td colspan="2"><input v-model="CommunityUpper" @input="handleRangeValue('CommunityUpper',$event.target.value,72)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                  </tr>
                  <tr>
                      <td>Independent</td>
                      <td colspan="2"><input v-model="IndependentLower" @input="handleRangeValue('IndependentLower',$event.target.value,72)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                      <td colspan="2"><input v-model="IndependentUpper" @input="handleRangeValue('IndependentUpper',$event.target.value,72)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                  </tr>
                  <tr>
                      <td>Intuitive</td>
                      <td colspan="2"><input v-model="IntuitiveLower" @input="handleRangeValue('IntuitiveLower',$event.target.value,72)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                      <td colspan="2"><input v-model="IntuitiveUpper" @input="handleRangeValue('IntuitiveUpper',$event.target.value,72)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                  </tr>
                  <tr>
                      <td>Cognitive</td>
                      <td colspan="2"><input v-model="CognitiveLower" @input="handleRangeValue('CognitiveLower',$event.target.value,72)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                      <td colspan="2"><input v-model="CognitiveUpper" @input="handleRangeValue('CognitiveUpper',$event.target.value,72)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                  </tr>
                  <tr>
                      <td>Practical</td>
                      <td colspan="2"><input v-model="PracticalLower" @input="handleRangeValue('PracticalLower',$event.target.value,72)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                      <td colspan="2"><input v-model="PracticalUpper" @input="handleRangeValue('PracticalUpper',$event.target.value,72)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                  </tr>
                  <tr>
                      <td>Creative</td>
                      <td colspan="2"><input v-model="CreativeLower" @input="handleRangeValue('CreativeLower',$event.target.value,72)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                      <td colspan="2"><input v-model="CreativeUpper" @input="handleRangeValue('CreativeUpper',$event.target.value,72)" min="0" maxlength="2" class="onlynumber" @keypress="numberRestriction"></td>
                  </tr>
                </tbody>
            </table>
          </div>

          <!--
          <div class="range-slider-wrapper d-flex align-items-center greysection">
            <span class="mr-3 range-slider-label">Builder</span>
            <MultiRangeSlider
              :min="0"
              :max="36"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="BuilderLower"
              :maxValue="BuilderUpper"
              @input="UpdateBuilderValues"
            />
          </div>
          

          <div class="range-slider-wrapper d-flex align-items-center whitesection">
            <span class="mr-3 range-slider-label">Merchant</span>
            <MultiRangeSlider
              :min="0"
              :max="36"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="MerchantLower"
              :maxValue="MerchantUpper"
              @input="UpdateMerchantValues"
            />
          </div>

          <div class="range-slider-wrapper d-flex align-items-center greysection">
            <span class="mr-3 range-slider-label">Innovator</span>
            <MultiRangeSlider
              :min="0"
              :max="36"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="InnovatorLower"
              :maxValue="InnovatorUpper"
              @input="UpdateInnovatorValues"
            />
          </div>

          <div class="range-slider-wrapper d-flex align-items-center whitesection">
            <span class="mr-3 range-slider-label">Banker</span>
            <MultiRangeSlider
              :min="0"
              :max="36"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="BankerLower"
              :maxValue="BankerUpper"
              @input="UpdateBankerValues"
            />
          </div>

          <div class="range-slider-wrapper d-flex align-items-center greysection">
            <span class="mr-3 range-slider-label">Intuitive</span>
            <MultiRangeSlider
              :min="0"
              :max="72"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="IntuitiveLower"
              :maxValue="IntuitiveUpper"
              @input="UpdateIntuitiveValues"
            />
          </div>

          <div class="range-slider-wrapper d-flex align-items-center whitesection">
            <span class="mr-3 range-slider-label">Cognitive</span>
            <MultiRangeSlider
              :min="0"
              :max="72"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="CognitiveLower"
              :maxValue="CognitiveUpper"
              @input="UpdateCognitiveValues"
            />
          </div>

          <div class="range-slider-wrapper d-flex align-items-center greysection">
            <span class="mr-3 range-slider-label">Practical</span>
            <MultiRangeSlider
              :min="0"
              :max="72"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="PracticalLower"
              :maxValue="PracticalUpper"
              @input="UpdatePracticalValues"
            />
          </div>

          <div class="range-slider-wrapper d-flex align-items-center whitesection">
            <span class="mr-3 range-slider-label">Creative</span>
            <MultiRangeSlider
              :min="0"
              :max="72"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="CreativeLower"
              :maxValue="CreativeUpper"
              @input="UpdateCreativeValues"
            />
          </div>

          <div class="range-slider-wrapper d-flex align-items-center greysection">
            <span class="mr-3 range-slider-label">Independent</span>
            <MultiRangeSlider
              :min="0"
              :max="72"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="IndependentLower"
              :maxValue="IndependentUpper"
              @input="UpdateIndependentValues"
            />
          </div>

          <div class="range-slider-wrapper d-flex align-items-center whitesection">
            <span class="mr-3 range-slider-label">Community</span>
            <MultiRangeSlider
              :min="0"
              :max="72"
              :step="1"
              :ruler="false"
              :label="true"
              :minValue="CommunityLower"
              :maxValue="CommunityUpper"
              @input="UpdateCommunityValues"
            />
          </div>
          -->
          <b-form-checkbox
            class="mt-3 custom-checkbox-fill p-0 text-center range-slider-checkbox"
            v-model="isDefault"
            name="check-default"
          >
            Default ?
          </b-form-checkbox>
        </b-form-group>
      </b-form>
      <b-button-group
        class="
          px-3
          w-100
          submit-form-btn
          btn-group
          d-inline-block
          text-center
          mt-4
          mb-5
        "
      >
        <b-button variant="outline-primary" @click="saveProfileInfo"
          >Save</b-button
        >
      </b-button-group>
    </div>

    <b-modal id="AssEmailModal" hide-footer>
			<template v-slot:modal-title>
				Edit Email Address
			</template>
			<div>
				<b-form>
          <b-form-group class="mulEmail m-auto">
              <multiselect 
              v-model="selectedEmailsPopUp" 
              tag-placeholder="Update email" 
              placeholder="Update a email" 
              :options=[] 
              :multiple="true" 
              :taggable="true" 
              @tag="updateAssessmentEmail" 
              :hideSelected="true" 
              :showLabels='false'>
              </multiselect>
          </b-form-group>
          <b-button variant="primary" class="btn-sm mt-2" @click="editEmailAddress" style="float:right;" >Update</b-button>
				</b-form>
			</div>
		</b-modal>

  </div>
</template>



<script>
import { db } from "src/db";
import { mapState } from "vuex";
// import MultiRangeSlider from "multi-range-slider-vue";
import Multiselect from 'vue-multiselect'
export default {
  components: {
    // MultiRangeSlider,
    Multiselect
  },
  name: "Assessment",
  computed: {
    getUserCCIProfileList() {
      let ccprof = [];
      if (this.user.hasOwnProperty("CciProfiles")) {
        ccprof = this.user.CciProfiles;
      } else {
        // ccprof.push({
        //     'Name':'Assessment 1',
        //     'BuilderLower':0,
        //     'BuilderUpper':36,
        //     'MerchantLower':0,
        //     'MerchantUpper':36,
        //     'InnovatorLower':0,
        //     'InnovatorUpper':36,
        //     'BankerLower':0,
        //     'BankerUpper':36,
        //     'IntuitiveLower':0,
        //     'IntuitiveUpper':0,
        //     'CognitiveLower':0,
        //     'CognitiveUpper':0,
        //     'PracticalLower':0,
        //     'PracticalUpper':0,
        //     'CreativeLower':0,
        //     'CreativeUpper':0,
        //     'IndependentLower':0,
        //     'IndependentUpper':0,
        //     'CommunityLower':0,
        //     'CommunityUpper':0,
        //     'ProfileId':'',
        //     'Default':false,
        // });
        db.doc(`Users/${this.user.id}`).update({ CciProfiles: [] });
      }
      if (!this.user.hasOwnProperty("CciURL")) {
         let url = 'https://tatext.com/assessment/'+this.user.Abbr;
         //eslint-disable-next-line
        console.log('aaaaaaaaaaa',url);
        db.doc(`Users/${this.user.id}`).update({ CciURL: url });
      }
      return ccprof;
    },
    ...mapState("firebase", ["user"]),
  },
  methods: {
    editEmailAddress() {
      if(this.user.hasOwnProperty('CciProfiles') && this.user.CciProfiles.length) {
        this.user.CciProfiles.forEach(element => {
          if(element.ProfileId == this.selectedEmailsPofileID) {
            var updatedCciProfiles = this.user.CciProfiles.map((p) => {
              if (p.ProfileId === this.selectedEmailsPofileID) {
                p.Emails = this.selectedEmailsPopUp;
              }
              return p;
            });
            db.doc(`Users/${this.user.id}`).update({
              CciProfiles: updatedCciProfiles,
            });
          }
        });
      }
      alert("Email Successfully Updated");
      this.$bvModal.hide('AssEmailModal');
    },
    editAssEmail(data) {
      this.selectedEmailsPopUp = [];
      this.selectedEmailsPofileID = '';
      this.selectedEmailsPofileID = data.item.ProfileId;
      if(data.item.hasOwnProperty('Emails')) {
        this.selectedEmailsPopUp = data.item.Emails;
      } 
      this.$bvModal.show('AssEmailModal');
    },
    // HANDLE RANGE VALUE DURING ENTER INPUT FIELD
    handleRangeValue(prop, value, maxRange) {
      this[prop] = value;
      if (this[prop] > maxRange) {
        this[prop] = '';
        alert(`You are entering more than ${maxRange}. Please enter the valid range(0-${maxRange}).`);
      }
    },
    numberRestriction(event) {
      if(
          event.keyCode !== 8 && // Allow backspace
          event.keyCode !== 0 && // Allow special keys
          (event.keyCode < 48 || event.keyCode > 57) // Restrict other keys
      ){
        event.preventDefault(); // Prevent the keypress event
      }
    },
    navigateToProfile() {
      //eslint-disable-next-line
      console.log(this.$route);
      // this.$router.push({ name: 'assessment/'+this.user.Abbr })
      // this.$router.push({name:'assessment', params: {userabbr: this.user.Abbr}});
      // this.$router.pop('/home');
      this.$router.push("/assessment/" + this.user.Abbr);
      // this.$router.push('/alert');
      // this.$router.push('/?redirect=' + this.$route.path)
    },
    UpdateBuilderValues(e) {
      this.BuilderLower = e.minValue;
      this.BuilderUpper = e.maxValue;
    },
    UpdateMerchantValues(e) {
      this.MerchantLower = e.minValue;
      this.MerchantUpper = e.maxValue;
    },
    UpdateInnovatorValues(e) {
      this.InnovatorLower = e.minValue;
      this.InnovatorUpper = e.maxValue;
    },
    UpdateBankerValues(e) {
      this.BankerLower = e.minValue;
      this.BankerUpper = e.maxValue;
    },
    UpdateIntuitiveValues(e) {
      this.IntuitiveLower = e.minValue;
      this.IntuitiveUpper = e.maxValue;
    },
    UpdateCognitiveValues(e) {
      this.CognitiveLower = e.minValue;
      this.CognitiveUpper = e.maxValue;
    },
    UpdatePracticalValues(e) {
      this.PracticalLower = e.minValue;
      this.PracticalUpper = e.maxValue;
    },
    UpdateCreativeValues(e) {
      this.CreativeLower = e.minValue;
      this.CreativeUpper = e.maxValue;
    },
    UpdateIndependentValues(e) {
      this.IndependentLower = e.minValue;
      this.IndependentUpper = e.maxValue;
    },
    UpdateCommunityValues(e) {
      this.CommunityLower = e.minValue;
      this.CommunityUpper = e.maxValue;
    },
    removeProfile(md) {
      if (confirm("Are you sure you want to delete this profile?")) {
        let i = 0;
        let ccProf = this.user.CciProfiles;
        for (let c of ccProf) {
          if (md.ProfileId == c.ProfileId) {
            ccProf.splice(i, 1);
          }
          i++;
        }
        db.doc(`Users/${this.user.id}`).update({ CciProfiles: ccProf });
      }
    },
    isAlreadyDefault() {
      let val = false;
      let cp = this.user.CciProfiles.find((cc) => cc.Default == true);
      if (cp) {
        val = true;
      }
      return val;
    },
    saveProfileInfo() {
      let newCciProfileArray = [];
      //eslint-disable-next-line
      console.log(this.BuilderLower);
      if (this.Name) {
        let newPData = {
          Name: this.Name,
          Emails: this.selectedEmails,
          BuilderLower: this.BuilderLower ? parseInt(this.BuilderLower) : 0,
          BuilderUpper: this.BuilderUpper ? parseInt(this.BuilderUpper) : 36,
          MerchantLower: this.MerchantLower ? parseInt(this.MerchantLower) : 0,
          MerchantUpper: this.MerchantUpper ? parseInt(this.MerchantUpper) : 36,
          InnovatorLower: this.InnovatorLower ? parseInt(this.InnovatorLower) : 0,
          InnovatorUpper: this.InnovatorUpper ? parseInt(this.InnovatorUpper) : 36,
          BankerLower: this.BankerLower ? parseInt(this.BankerLower) : 0,
          BankerUpper: this.BankerUpper ? parseInt(this.BankerUpper) : 36,
          // 'IntuitiveLower':this.BuilderLower+this.MerchantLower,
          // 'IntuitiveUpper':this.BuilderUpper+this.MerchantUpper,
          // 'CognitiveLower':this.InnovatorLower+this.BankerLower,
          // 'CognitiveUpper':this.InnovatorUpper+this.BankerUpper,
          // 'PracticalLower':this.BuilderLower+this.BankerLower,
          // 'PracticalUpper':this.BuilderUpper+this.BankerUpper,
          // 'CreativeLower':this.MerchantLower+this.InnovatorLower,
          // 'CreativeUpper':this.MerchantUpper+this.InnovatorUpper,
          // 'IndependentLower':this.BuilderLower+this.InnovatorLower,
          // 'IndependentUpper':this.BuilderUpper+this.InnovatorUpper,
          // 'CommunityLower':this.BankerLower+this.MerchantLower,
          // 'CommunityUpper':this.BankerUpper+this.MerchantUpper,
          IntuitiveLower: this.IntuitiveLower ? parseInt(this.IntuitiveLower) : 0,
          IntuitiveUpper: this.IntuitiveUpper ? parseInt(this.IntuitiveUpper) : 72,
          CognitiveLower: this.CognitiveLower ? parseInt(this.CognitiveLower) : 0,
          CognitiveUpper: this.CognitiveUpper ? parseInt(this.CognitiveUpper) : 72,
          PracticalLower: this.PracticalLower ? parseInt(this.PracticalLower) : 0,
          PracticalUpper: this.PracticalUpper ? parseInt(this.PracticalUpper) : 72,
          CreativeLower: this.CreativeLower ? parseInt(this.CreativeLower) : 0,
          CreativeUpper: this.CreativeUpper ? parseInt(this.CreativeUpper) : 72,
          IndependentLower: this.IndependentLower ? parseInt(this.IndependentLower) : 0,
          IndependentUpper: this.IndependentUpper ? parseInt(this.IndependentUpper) : 72,
          CommunityLower: this.CommunityLower ? parseInt(this.CommunityLower) : 0,
          CommunityUpper: this.CommunityUpper ? parseInt(this.CommunityUpper) : 72,
          ProfileId: this.$uuid.v1(),
          Default: this.isDefault,
        };
        if (this.user.hasOwnProperty("CciProfiles") && this.user.CciProfiles) {
          if (this.isDefault && this.isAlreadyDefault()) {
            alert("Only one profile can be a default per User");
            return;
          }
          newCciProfileArray = this.user.CciProfiles;
          newCciProfileArray.push(newPData);
        } else {
          newCciProfileArray.push(newPData);
        }
        this.isShow = false;
        this.Name = "";
        this.selectedEmails = [];
        this.isDefault = false;
        this.BuilderLower = 0;
        this.BuilderUpper = 36;
        this.MerchantLower = 0;
        this.MerchantUpper = 36;
        this.InnovatorLower = 0;
        this.InnovatorUpper = 36;
        this.BankerLower = 0;
        this.BankerUpper = 36;
        this.IntuitiveLower = 0;
        this.IntuitiveUpper = 72;
        this.CognitiveLower = 0;
        this.CognitiveUpper = 72;
        this.PracticalLower = 0;
        this.PracticalUpper = 72;
        this.CreativeLower = 0;
        this.CreativeUpper = 72;
        this.IndependentLower = 0;
        this.IndependentUpper = 72;
        this.CommunityLower = 0;
        this.CommunityUpper = 72;

        db.doc(`Users/${this.user.id}`).update({
          CciProfiles: newCciProfileArray,
        });
        setTimeout(() => {
          this.isShow = true;
        }, 100);
      } else {
        alert("Profile Name is required.");
      }
    },
    addAssessmentEmail(newTag) {
        const email = newTag.trim();
        if (email && this.isValidEmail(email)) {
          this.selectedEmails.push(email);
        }
    },
    updateAssessmentEmail(newTag) {
        const email = newTag.trim();
        if (email && this.isValidEmail(email)) {
          this.selectedEmailsPopUp.push(email);
        }
    },
    isValidEmail(email) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    }
  },
  data() {
    return {
      fields: [{ key: "Name", sortable: true }, "Emails", "Default", "Profile", "Delete"],
      isShow: true,
      isDefault: false,
      Name: "",
      BuilderLower: 0,
      BuilderUpper: 36,
      MerchantLower: 0,
      MerchantUpper: 36,
      InnovatorLower: 0,
      InnovatorUpper: 36,
      BankerLower: 0,
      BankerUpper: 36,
      IntuitiveLower: 0,
      IntuitiveUpper: 72,
      CognitiveLower: 0,
      CognitiveUpper: 72,
      PracticalLower: 0,
      PracticalUpper: 72,
      CreativeLower: 0,
      CreativeUpper: 72,
      IndependentLower: 0,
      IndependentUpper: 72,
      CommunityLower: 0,
      CommunityUpper: 72,
      selectedEmails: [],
      selectedEmailsPopUp: [],
      selectedEmailsPofileID: '',
    };
  },
};
</script>

<style scoped>
.page-wrapper {
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
}
.form-title {
  width: 100%;
  text-align: center;
  display: inline-block;
}
.slider-input {
  border: none;
  height: 50px;
  max-width: 310px;
  margin-bottom: 30px !important;
}
.multi-range-slider {
  width: 100% !important;
}
.range-slider-label {
  min-width: 150px;
  max-width: 200px;
  text-align: center;
  font-weight: 600;
}
.btn-group button.btn.btn-outline-primary {
  background: #042b79;
  color: #fff;
  border-color: #042b79;
}
.page-wrapper .btn {
  max-width: 150px !important;
  min-width: 150px;
}

.core-capacity-table .table thead th:last-child {
  width: 100px !important;
  text-align: center !important;
}
.core-capacity-table {
  max-width: 90%;
  margin: auto;
}
.range-slider-wrapper {
  max-width: 80%;
  margin: auto;
}
.page-wrapper .max-w-auto{
  max-width: 100% !important;
}
.assessmentRangeTable.RangeTableContent td[colspan="2"]:nth-child(2) {
    background-color: rgb(170, 167, 167);
}
.assessmentRangeTable.RangeTableContent td[colspan="2"]:nth-child(3) {
    background-color: rgb(157, 173, 181);
}
.assessmentRangeTable.RangeTableContent td{
  padding: 5px;
}
.assessmentRangeTable.RangeTableContent th:first-child{
  padding-left: 5px;
}
.assessmentRangeTable.RangeTableContent .typesTitle{
  margin: 30px 0px 10px 5px;
}
.assessmentRangeTable.RangeTableContent {
    background: #fff;
    padding: 30px;
    margin: 0px 15%;
}
.assessmentRangeTable.RangeTableContent table thead th{
  border-bottom: 2px solid #000;
}
.assessmentRangeTable.RangeTableContent table thead th{
  width: 33%!important;
}
.assessmentRangeTable input.onlynumber{
  outline: none;
  height: 26px;
  width: 60%;
  text-align: center;
}
.editAssEmail{
  float: right;
  cursor: pointer;
}
</style>

<style>
.mulEmail .multiselect__option{
  display: none;
}
.mulEmail .multiselect__tags {
  min-height: 50px;
  display: block;
  padding: 8px 40px 0 8px;
  border-radius: 0;
  border: none;
  background: #fff;
}
.multi-range-slider .thumb::before{
	border: solid 5px #042b79;
}
</style>